import React from 'react';
import styled from 'styled-components';
import { theme } from 'src/styles/theme';
import QcastLogo from "src/assets/brands/loader.svg";

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: number;
  badge?: React.ReactNode;
}

const AvatarContainer = styled.div<{ size: number }>`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
`;

const AvatarImage = styled.div<{ size: number; src?: string }>`
  width: 100%;
  height: 100%;
  border-radius: ${theme.borderRadius.circle};
  background-color: ${theme.colors.gray[300]};
  overflow: hidden;
  box-shadow: ${theme.shadows.avatarShadow};
  border: 2px solid rgba(255, 255, 255, 0.2);
  
  ${({ src }) => src && `
    background-image: url(${src});
    background-size: cover;
    background-position: center;
  `}
`;

const AvatarFallback = styled.div<{ size: number }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.white};
  font-size: ${({ size }) => `${size * 0.4}px`};
  font-weight: ${theme.fontWeights.semiBold};
  border-radius: ${theme.borderRadius.circle};
  box-shadow: ${theme.shadows.avatarShadow};
  border: 2px solid rgba(255, 255, 255, 0.2);
`;

const BadgeContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
`;

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt = 'User avatar',
  size = 40,
  badge,
}) => {
  // Get initials from alt text for fallback
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  return (
    <AvatarContainer size={size}>
      {src ? (
        <AvatarImage size={size} src={src} />
      ) : (
        
        <AvatarFallback size={size}>{"Q"}</AvatarFallback>
      )}
      {badge && <BadgeContainer>{badge}</BadgeContainer>}
    </AvatarContainer>
  );
}; 